import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=a6b30a00&scoped=true"
import script from "./VerificationCode.vue?vue&type=script&lang=js"
export * from "./VerificationCode.vue?vue&type=script&lang=js"
import style0 from "./VerificationCode.vue?vue&type=style&index=0&id=a6b30a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b30a00",
  null
  
)

export default component.exports